<div class="arrow-container">
  <mat-icon class="arrow arrow-left" (click)="updateOffset(-1)">arrow_back</mat-icon>
  <mat-icon class="arrow arrow-right" (click)="updateOffset(1)" [ngClass]="{'arrow-disabled': !canGoNext}">arrow_forward</mat-icon>
</div>
